export const INITIAL_PRODUCTS = [
  {
    id: "PROD-001",
    name: "BPT 5204 Premium Sona Masoori Raw Rice (25kg Bag)",
    category: "Grains & Cereals",
    brand: "Lalitha Brand / Kurnool Sona",
    unit: "Bag",
    barcode: "8901234500018",
    MRP: 1650,
    purchasePrice: 1320,
    retailPrice: 1540,
    wholesalePrice: 1410,
    reorderLevel: 25,
    description: "Aged 12+ months Telangana & Kurnool authentic Sona Masoori lightweight raw rice."
  },
  {
    id: "PROD-002",
    name: "Daawat Rozana Super Basmati Rice (5kg Bag)",
    category: "Grains & Cereals",
    brand: "Daawat",
    unit: "Bag",
    barcode: "8901234500025",
    MRP: 480,
    purchasePrice: 360,
    retailPrice: 440,
    wholesalePrice: 395,
    reorderLevel: 20,
    description: "Long grain aromatic Basmati rice for Hyderabadi biryani and pulao cooking."
  },
  {
    id: "PROD-003",
    name: "Aashirvaad Shudh Chakki Superior MP Whole Wheat Atta (10kg)",
    category: "Flours & Grains",
    brand: "Aashirvaad (ITC)",
    unit: "Bag",
    barcode: "8901234500032",
    MRP: 495,
    purchasePrice: 390,
    retailPrice: 460,
    wholesalePrice: 420,
    reorderLevel: 30,
    description: "100% whole wheat chakki ground MP grain flour with zero maida."
  },
  {
    id: "PROD-004",
    name: "Freedom Refined Sunflower Oil 15L Commercial Tin",
    category: "Edible Oils & Ghee",
    brand: "Freedom (Gemini Edibles)",
    unit: "Tin",
    barcode: "8901234500049",
    MRP: 2150,
    purchasePrice: 1780,
    retailPrice: 2020,
    wholesalePrice: 1860,
    reorderLevel: 15,
    description: "Fortified with Vitamin A & D, non-greasy sunflower cooking oil for commercial kitchens."
  },
  {
    id: "PROD-005",
    name: "Fortune Sunlite Refined Sunflower Oil (1L Pouch)",
    category: "Edible Oils & Ghee",
    brand: "Fortune",
    unit: "Pouch",
    barcode: "8901234500056",
    MRP: 145,
    purchasePrice: 112,
    retailPrice: 135,
    wholesalePrice: 122,
    reorderLevel: 50,
    description: "Heart-friendly sunflower cooking oil for everyday household cooking."
  },
  {
    id: "PROD-006",
    name: "Vijaya Telangana Dairy Pure Ghee (1L Tin)",
    category: "Edible Oils & Ghee",
    brand: "Vijaya Dairy",
    unit: "Tin",
    barcode: "8901234500063",
    MRP: 680,
    purchasePrice: 530,
    retailPrice: 640,
    wholesalePrice: 580,
    reorderLevel: 20,
    description: "Traditional aromatic cow & buffalo ghee from Telangana State Dairy Federation."
  },
  {
    id: "PROD-007",
    name: "Desi Toor Dal / Kandipappu Nizamabad Polished (1kg Pkt)",
    category: "Pulses & Dals",
    brand: "Kirana Selection",
    unit: "Pkt",
    barcode: "8901234500070",
    MRP: 185,
    purchasePrice: 142,
    retailPrice: 170,
    wholesalePrice: 154,
    reorderLevel: 40,
    description: "Unpolished unadulterated high-protein yellow toor dal for Sambar and Pappu."
  },
  {
    id: "PROD-008",
    name: "Warangal Hot Teja Red Chilly Powder (500g Pkt)",
    category: "Spices & Condiments",
    brand: "Everest / Warangal Spices",
    unit: "Pkt",
    barcode: "8901234500087",
    MRP: 220,
    purchasePrice: 165,
    retailPrice: 205,
    wholesalePrice: 180,
    reorderLevel: 25,
    description: "Fiery spicy red chilly powder ground from authentic Warangal & Guntur crop."
  },
  {
    id: "PROD-009",
    name: "Tata Salt Vacuum Evaporated Iodized (1kg Pkt)",
    category: "Spices & Condiments",
    brand: "Tata",
    unit: "Pkt",
    barcode: "8901234500094",
    MRP: 28,
    purchasePrice: 21,
    retailPrice: 26,
    wholesalePrice: 23,
    reorderLevel: 60,
    description: "Desh Ka Namak - vacuum evaporated iodized edible crystal salt."
  },
  {
    id: "PROD-010",
    name: "Priya Ginger Garlic Paste Commercial Pack (1kg Pouch)",
    category: "Spices & Condiments",
    brand: "Priya (Ushodaya)",
    unit: "Pouch",
    barcode: "8901234500100",
    MRP: 160,
    purchasePrice: 115,
    retailPrice: 145,
    wholesalePrice: 128,
    reorderLevel: 20,
    description: "Fresh crushed ginger garlic paste for restaurant and catering marinades."
  },
  {
    id: "PROD-011",
    name: "MTR Ready-To-Eat Hyderabadi Biryani Mix & Masala (200g)",
    category: "Packaged Foods",
    brand: "MTR",
    unit: "Pkt",
    barcode: "8901234500117",
    MRP: 95,
    purchasePrice: 68,
    retailPrice: 88,
    wholesalePrice: 76,
    reorderLevel: 30,
    description: "Authentic spice blend with shahi jeera, star anise, and elaichi."
  },
  {
    id: "PROD-012",
    name: "Parle-G Gold Glucose Biscuits Mega Pack (1kg)",
    category: "Snacks & Biscuits",
    brand: "Parle",
    unit: "Pack",
    barcode: "8901234500124",
    MRP: 140,
    purchasePrice: 108,
    retailPrice: 130,
    wholesalePrice: 118,
    reorderLevel: 35,
    description: "Iconic tea-time glucose energy biscuits in family economy pack."
  },
  {
    id: "PROD-013",
    name: "Surf Excel Easy Wash Detergent Powder (5kg Bag)",
    category: "Personal & Home Care",
    brand: "Surf Excel (HUL)",
    unit: "Bag",
    barcode: "8901234500131",
    MRP: 650,
    purchasePrice: 490,
    retailPrice: 595,
    wholesalePrice: 535,
    reorderLevel: 15,
    description: "Superior stain removal laundry washing powder for hand & machine wash."
  },
  {
    id: "PROD-014",
    name: "Red Label Strong CTC Tea Powder (1kg Pkt)",
    category: "Beverages & Tea",
    brand: "Brooke Bond (HUL)",
    unit: "Pkt",
    barcode: "8901234500148",
    MRP: 480,
    purchasePrice: 375,
    retailPrice: 445,
    wholesalePrice: 405,
    reorderLevel: 25,
    description: "Rich taste and strong aroma CTC tea blend for Irani chai and home tea."
  }
];

export const initialProducts = INITIAL_PRODUCTS;

